import { useState, useEffect, forwardRef } from 'react';
import { Link, useNavigate } from "react-router-dom";

import styledComponent from "styled-components";
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import {
    Autocomplete,
    Box,
    Divider,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    Typography,
    TextField,
    Button,
    Menu,
    MenuItem,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Modal,
    InputAdornment,
    InputLabel,
    IconButton,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    RadioGroup,
    Radio,
    SwipeableDrawer,
    Snackbar,
    Select,
    Stack,
    Paper
  } from "@mui/material";

import MuiAlert from '@mui/material/Alert';

import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import PasswordIcon from '@mui/icons-material/Password';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import axios from  "axios";
import { Formik } from 'formik';

import PropTypes from 'prop-types';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { parse } from 'date-fns';


const Container = styledComponent.div`
    display: flex;
    padding: 25px 17px;
`;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '68vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const footerStyle = {
    backgroundColor: "#e1e4eb",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "55px",
    paddingTop: "10px",
    width: "100%",
    display: "flex"
};

const footerItemStyle = {
    flexGrow: '1',
    width: '25%',
    textAlign: 'center'
}

const Puller = styled(Box)(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: theme.palette.mode === 'light' ? grey[300] : grey[900],
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
}));

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
}));

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SimpleDialog(props) {
    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
      onClose(selectedValue);
    };

    const handleChangeRadio = (event) => {
        onClose(event.target.value);
    };
  
    return (
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>
            <Typography variant="subtitle2">Pilih Mode Ready Stock-mu</Typography>
        </DialogTitle>
            <DialogContent dividers>
                <RadioGroup
                    aria-label="ringtone"
                    name="ringtone"
                    value={selectedValue}
                    onChange={handleChangeRadio}
                >
                    <FormControlLabel
                        value="hemat"
                        key={0}
                        control={<Radio />}
                        label="Mode Hemat"
                    />
                    <FormControlLabel
                        value="cantik"
                        key={1}
                        control={<Radio />}
                        label="Mode Cantik"
                    />
                </RadioGroup>
            </DialogContent>
      </Dialog>
    );
  }
  
SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
  

const FooterNav = () => {
    const navigate = useNavigate();
    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedValue, setSelectedValue] = useState(
        localStorage.getItem('mode') !== null
            ? localStorage.getItem('mode')
            : 'cantik'
    );

    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const [openModalAlamat, setOpenModalAlamat] = useState(false);
    const [openModalPwd, setOpenModalPwd] = useState(false);

    const [profile, setProfile] = useState({});

    const [subdistricts, setSubdistricts] = useState([]);
    const [valueSubdistrict, setValueSubdistrict] = useState(subdistricts[0]);
    const [inputSdValue, setInputSdValue] = useState(null);
    const handleSelectSubdistrict = (e, val) => {
        setValueSubdistrict(val);
        setInputSdValue(val.subdistrict_id);
    };
    

    const [cities, setCities] = useState([]);
    const [valueCity, setValueCity] = useState(cities[0]);
    const [inputCityValue, setInputCityValue] = useState(null);
    const handleSelectCity = async (e, val) => {
        setValueCity(val);
        setInputCityValue(val.city_id);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${val.city_id}`);
            setSubdistricts(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [provinces, setProvinces] = useState([]);
    const [valueProvince, setValueProvince] = useState(provinces[0]);
    const [inputProvValue, setInputProvValue] = useState(null);
    const handleSelectProvince = async (e, val) => {
        setValueProvince(val);
        setInputProvValue(val.province_id);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${val.province_id}`);
            setCities(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };
    
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });

        const getProfile = async () => {
            try {
                const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/profile`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                setProfile(getData.data.result);

                const getProvinces = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/province`);
                await setProvinces(getProvinces.data.result);
                const provinceValue = getProvinces.data.result.filter((item) => item.province_id === parseInt(getData.data.result.provinsi));
                setValueProvince(provinceValue[0]);

                const getCity = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${provinceValue[0].province_id}`);
                await setCities(getCity.data.result);
                const cityValue = getCity.data.result.filter((item) => item.city_id === parseInt(getData.data.result.kota));
                setValueCity(cityValue[0]);

                const getSubdistritct = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${cityValue[0].city_id}`);
                await setSubdistricts(getSubdistritct.data.result);
                const subDistrictValue = getSubdistritct.data.result.filter((item) => item.subdistrict_id === parseInt(getData.data.result.kecamatan));
                setValueSubdistrict(subDistrictValue[0]);

            } catch (err) {
              console.log(err);
            }
        };

        getProfile();
    };

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };
    
    const handleCloseDialog = (value) => {
        localStorage.setItem('mode', value);
        navigate('/dashboard/readystok');
        setOpenDialog(false);
        setSelectedValue(value);
    };

    const handleOpenModalAlamat = () => {
        setOpenModalAlamat(true);
    };

    const handleCloseModalAlamat = () => {
        setOpenModalAlamat(false);
    };

    const handleCloseModalPwd = () => {
        setOpenModalPwd(false);
    };

    const handleOpenModalPwd = () => {
        setOpenModalPwd(true);
    };

    const listSetting = (anchor) => (
        <Box
          sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                <ListItem button key={0} onClick={() => navigate('/dashboard/rekeningku')}>
                    <ListItemIcon><AccountBalanceWalletIcon /></ListItemIcon>
                    <ListItemText primary="Data rekeningku" />
                </ListItem>
                <ListItem button key={1} onClick={handleClickOpenDialog}>
                    <ListItemIcon><AppRegistrationIcon /></ListItemIcon>
                    <ListItemText primary="Set mode default" />
                </ListItem>
                <ListItem button key={2} onClick={handleOpenModalAlamat}>
                    <ListItemIcon><LocationOnIcon /></ListItemIcon>
                    <ListItemText primary="Setting Alamatku" />
                </ListItem>
                <ListItem button key={3} onClick={handleOpenModalPwd}>
                    <ListItemIcon><PasswordIcon /></ListItemIcon>
                    <ListItemText primary="Ubah Password" />
                </ListItem>
            </List>
        </Box>
    );

    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);
    const handleClickShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

    return (
        <Container>
            <Snackbar
                open={openAlert}
                autoHideDuration={2500}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                key={'top' + 'center'}
            >
                <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            <Modal
                open={openModalAlamat}
                onClose={handleCloseModalAlamat}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Formik
                        initialValues={{ alamat: null, kodepos: null, titikkordinat: null, provinsi: null, kota: null, kecamatan: null }}
                        validate={values => {
                            const errors = {};
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            
                            values.provinsi = inputProvValue;
                            values.kota = inputCityValue;
                            values.kecamatan = inputSdValue;

                            const filteredVal = Object.keys(values).reduce((newObj, key) => {
                                const value = values[key];
                                if (value !== null) {
                                    newObj[key] = value;
                                }
                                return newObj;
                            }, {});
                            if (Object.keys(filteredVal).length === 0) {
                                setAlertStatus('warning');
                                setAlertMessage('Tidak ada perubahan')
                                setOpenAlert(true);
                                setSubmitting(false);
                            } else {
                                try {
                                    await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/profile/update`, filteredVal, {
                                        headers: {
                                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                        }
                                    });
                                    
                                    const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/profile`, {
                                        headers: {
                                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                        }
                                    });
                                    setProfile(getData.data.result);
                                    const getProvinces = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/province`);
                                    await setProvinces(getProvinces.data.result);
                                    
                                    const provinceValue = getProvinces.data.result.filter((item) => item.province_id === parseInt(getData.data.result.provinsi));
                                    setValueProvince(provinceValue[0]);
                    
                                    const getCity = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${provinceValue[0].province_id}`);
                                    const cityValue = getCity.data.result.filter((item) => item.city_id === parseInt(getData.data.result.kota));
                                    setValueCity(cityValue[0]);
                    
                                    const getSubdistritct = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${cityValue[0].city_id}`);
                                    const subDistrictValue = getSubdistritct.data.result.filter((item) => item.subdistrict_id === parseInt(getData.data.result.kecamatan));
                                    setValueSubdistrict(subDistrictValue[0]);
    
                                    setAlertStatus('success');
                                    setAlertMessage('Update alamat berhasil');
                                    setOpenAlert(true);
                                    handleCloseModalAlamat();
                                } catch (err) {
                                    console.log(err);
                                    setSubmitting(false);
                                }
                            }
                        }}
                    >
                        {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                        }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                    <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                        Setting Alamatku
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        required
                                        fullWidth
                                        multiline
                                        rows={3}
                                        label="Alamat"
                                        onChange={handleChange}
                                        name="alamat"
                                        defaultValue={profile?.alamat}
                                    />
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.alamat && touched.alamat && errors.alamat}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        required
                                        fullWidth
                                        label="Kode Pos"
                                        onChange={handleChange}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                        name="kodepos"
                                        defaultValue={profile?.kodepos}
                                    />
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.kodepos && touched.kodepos && errors.kodepos}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <HtmlTooltip
                                        enterTouchDelay={0}
                                        leaveTouchDelay={5000}
                                        title={
                                            <>
                                              <Typography variant="subtitle2">1. Buka aplikasi Google Maps</Typography>
                                              <Typography variant="subtitle2">2. Cari Lokasi kita, Zoom sampai lokasi terlihat detail</Typography>
                                              <Typography variant="subtitle2">3. Tekan dan Tahan sampai muncul titik kordinat berada di atas (contoh:-6,121.232.....)</Typography>
                                              <Typography variant="subtitle2">4. Copy Paste Nomor tersebut, lalu masukan pada form</Typography>
                                            </>
                                        }
                                    >
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            fullWidth
                                            label="Titik Koordinat"
                                            onChange={handleChange}
                                            name="titikkordinat"
                                            defaultValue={profile?.titikkordinat}
                                        />
                                    </HtmlTooltip>
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.titikkordinat && touched.titikkordinat && errors.titikkordinat}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                        Provinsi Tujuan
                                    </InputLabel>
                                    <Autocomplete
                                        fullWidth
                                        size="small"
                                        value={valueProvince}
                                        onChange={handleSelectProvince}
                                        options={provinces}
                                        getOptionLabel={(option) => option.province_name}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                {option.province_name}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>                            
                                    <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                        Kota/Kabupaten Tujuan
                                    </InputLabel>
                                    <Autocomplete
                                        fullWidth
                                        // disabled={cities.length === 0}
                                        size="small"
                                        value={valueCity}
                                        onChange={handleSelectCity}
                                        options={cities}
                                        getOptionLabel={(option) => option.city_name}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                {option.city_name}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                        Kecamatan Tujuan
                                    </InputLabel>
                                    <Autocomplete
                                        fullWidth
                                        // disabled={subdistricts.length === 0}
                                        size="small"
                                        value={valueSubdistrict}
                                        onChange={handleSelectSubdistrict}
                                        options={subdistricts}
                                        getOptionLabel={(option) => option.subdistrict_name}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                {option.subdistrict_name}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                    <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                                </Grid>
                            </Grid>
                        </form>
                        )}
                    </Formik>
                </Box>
            </Modal>
            <Modal
                open={openModalPwd}
                onClose={handleCloseModalPwd}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Formik
                        initialValues={{ oldpassword: null, newpassword: null, confirmpassword: null }}
                        validate={values => {
                            const errors = {};
                            if(values.newpassword !== values.confirmpassword) {
                                errors.confirmpassword = 'Konfirmasi password baru berbeda'
                            }
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            const filteredVal = Object.keys(values).reduce((newObj, key) => {
                                const value = values[key];
                                if (value !== null) {
                                    newObj[key] = value;
                                }
                                return newObj;
                            }, {});
                            if (Object.keys(filteredVal).length === 0) {
                                setAlertStatus('warning');
                                setAlertMessage('Tidak ada perubahan')
                                setOpenAlert(true);
                                setSubmitting(false);
                            } else {
                                try {
                                    await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/change-password`, filteredVal, {
                                        headers: {
                                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                        }
                                    });
                                    setAlertStatus('success');
                                    setAlertMessage('Update password berhasil');
                                    setOpenAlert(true);
                                    handleCloseModalPwd();
                                } catch (err) {
                                    console.log(err);
                                    setAlertStatus('error');
                                    setAlertMessage(err.response.data.message);
                                    setOpenAlert(true);
                                    setSubmitting(false);
                                }
                            }
                        }}
                    >
                        {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                        }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                    <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                        Ubah password
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        required
                                        fullWidth
                                        type={showPassword ? "text" : "password"}
                                        label="Password lama"
                                        onChange={handleChange}
                                        name="oldpassword"
                                        InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  aria-label="toggle password visibility"
                                                  onClick={handleClickShowPassword}
                                                >
                                                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                </IconButton>
                                              </InputAdornment>
                                            )
                                        }}
                                    />
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.oldpassword && touched.oldpassword && errors.oldpassword}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        required
                                        fullWidth
                                        type={showNewPassword ? "text" : "password"}
                                        label="Password Baru"
                                        onChange={handleChange}
                                        name="newpassword"
                                        InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  aria-label="toggle password visibility"
                                                  onClick={handleClickShowNewPassword}
                                                >
                                                  {showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                </IconButton>
                                              </InputAdornment>
                                            )
                                        }}
                                    />
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.newpassword && touched.newpassword && errors.newpassword}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        required
                                        fullWidth
                                        type={showConfirmPassword ? "text" : "password"}
                                        label="Konfirmasi Password Baru"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="confirmpassword"
                                        InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  aria-label="toggle password visibility"
                                                  onClick={handleClickShowConfirmPassword}
                                                >
                                                  {showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                </IconButton>
                                              </InputAdornment>
                                            )
                                        }}
                                    />
                                    <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                        {errors.confirmpassword && touched.confirmpassword && errors.confirmpassword}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                    <Button variant="contained" type="submit" disabled={isSubmitting}>Ubah password</Button>
                                </Grid>

                            </Grid>
                        </form>
                        )}
                    </Formik>
                </Box>
            </Modal>
            <SimpleDialog
                selectedValue={selectedValue}
                open={openDialog}
                onClose={handleCloseDialog}
            />
            <SwipeableDrawer
                anchor="bottom"
                open={state['bottom']}
                onClose={toggleDrawer('bottom', false)}
                onOpen={toggleDrawer('bottom', true)}
            >
                <Puller />
                <br/>
                {listSetting('bottom')}
            </SwipeableDrawer>
            <div style={footerStyle}>
                <div style={footerItemStyle}>
                    <HomeIcon color="primary" onClick={() => navigate('/dashboard')} />
                    <Typography variant="body2">Home</Typography>
                </div>
                <div style={footerItemStyle}>
                    <InfoIcon color="primary" onClick={() => navigate('/dashboard/info')} />
                    <Typography variant="body2">W-Info</Typography>
                </div>
                <div style={footerItemStyle}>
                    <AutoStoriesIcon color="primary" onClick={() => navigate('/dashboard/tutorial')} />
                    <Typography variant="body2">Tutorial</Typography>
                </div>
                <div style={footerItemStyle}>
                    <SettingsIcon color="primary" onClick={toggleDrawer('bottom', true)} />
                    <Typography variant="body2">Setting</Typography>
                </div>
                <div style={footerItemStyle}>
                    <AccountCircleIcon color="primary" onClick={() => navigate('/dashboard/profile')} />
                    <Typography variant="body2">Profile</Typography>
                </div>
            </div>
        </Container>
    )
}

export default FooterNav
